import { useState, forwardRef, useImperativeHandle } from 'react'
import Typography from '@mui/material/Typography'
import {
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@mui/material'
import ExpandMoreIcon from '../../images/ExpandMoreIcon.svg'

import { createUpdateStaff, updateTBD } from '../../services/EventService'

import { Approver } from '../../components/Approver/Approver'
import { Staff, StaffType } from '../../services/Types'
import { copyObj } from '../../services/Helper'

const SpeakerAndStaffSupport = forwardRef((props: any, ref: any) => {
  useImperativeHandle(ref, () => ({
    createNewStaff: (eventId: number) => {
      let message = createStaff(eventId)
      return message
    },
    validateNewStaff: () => {
      let message = validateStaff()
      return message
    }
  }))

  const [showErrorMessage, setErrorMessage] = useState('')
  const [presenterErrors, setPresenterErrors] = useState<number[]>([])
  const [moderatorErrors, setModeratorErrors] = useState<number[]>([])

  const [tbd_presenters, setTbdPresenters] = useState(0)
  const [tbd_moderators, setTbdModerators] = useState(0)
  const [tbd_supportstaff, setTbdSupportstaff] = useState(0)

  const [staff, setStaff] = useState<Staff[]>([])
  const [event, setEvent] = useState<any>({
    overHundredParticipants: true,
    sendInvitation: 'OWN',
    invitationDistributionList: '',
    invitationNotes: ''
  })

  const handleStaffChange = (updatedStaff: Staff[], staff_type: StaffType) => {
    let newStaff: Staff[] = copyObj(staff)
    newStaff = newStaff.filter(s => s.staff_type !== staff_type)
    newStaff = [...newStaff, ...updatedStaff]
    setStaff(newStaff)
  }

  const updateTbd = async (eventId: number) => {
    try {
      const results = await updateTBD(
        eventId,
        tbd_presenters,
        tbd_moderators,
        tbd_supportstaff
      )
      const { data } = results
      if (data) {
        if (data.updateTBD.statusCode === 200) {
          // navigate('/dateAndTime/'+id);
        } else {
          showErrorPopup('Internal server error')
        }
      } else {
        showErrorPopup('Internal server error')
      }
    } catch (error) {
      showErrorPopup('Internal server error')
    }
  }

  const showErrorPopup = (message: string) => {
    setErrorMessage(message)
    setTimeout(() => {
      setErrorMessage('')
    }, 3000)
  }

  const validateStaff = () => {
    let errorMessage = ''
    try {
      let presenters = staff.filter(
        (x: any) => x.staff_type === StaffType.PRESENTERS
      )
      let moderators = staff.filter(
        (x: any) => x.staff_type === StaffType.MODERATORS
      )

      let presenterErrorIndices: number[] = [],
        moderatorErrorIndices: number[] = []

        //Please add Moderator and Presenter information or select TBD.
      if (
        moderators.length === 0 &&
        !tbd_moderators &&
        presenters.length === 0 &&
        !tbd_presenters
      ) {
        errorMessage = 'Please add Moderator and Presenter information or select TBD.'
        return errorMessage
      }

      // moderators validation
      if (moderators.length === 0 && !tbd_moderators) {
        errorMessage = 'Please add Moderator information or select TBD.'
        return errorMessage
      }
      moderators.forEach((x: any, index: number) => {
        if (
          !x.name.trim() ||
          !x.email.trim() ||
          !x.phone.trim() ||
          !x.programOffice.trim() ||
          !x.jobTitle.trim() ||
          !new RegExp(/\S+@\S+\.\S+/).test(x.email) ||
          !new RegExp(/^\d+$/).test(x.phone) ||
          x.phone.length !== 10
        ) {
          moderatorErrorIndices.push(index)
        }
      })
      setModeratorErrors(moderatorErrorIndices)
      if (moderatorErrorIndices.length > 0) return

      // presenters validation
      if (presenters.length === 0 && !tbd_presenters) {
        errorMessage = 'Please add Presenter information or select TBD.'
        return errorMessage
      }
      presenters.forEach((x: any, index: number) => {
        if (
          !x.name.trim() ||
          !x.email.trim() ||
          !x.programOffice.trim() ||
          !x.jobTitle.trim() ||
          !new RegExp(/\S+@\S+\.\S+/).test(x.email) ||
          (x.phone.trim() && (!new RegExp(/^\d+$/).test(x.phone) || x.phone.length !== 10))
        ) {
          presenterErrorIndices.push(index)
        }
      })
      setPresenterErrors(presenterErrorIndices)
      if (presenterErrorIndices.length > 0) return
    } catch (error: any) {
      errorMessage = 'Internal server error'
      return errorMessage
    }
    return errorMessage
  }

  const createStaff = async (eventId: number) => {
    let errorMessage = ''
    try {
      await updateTbd(eventId)
      const results = await createUpdateStaff(eventId, staff)
      const { data } = results
      if (data) {
        if (data.createUpdateStaff.statusCode === 200) {
          //   if (event.eventType === 'Webinar') navigate('/audience/' + event.id)
          //   else navigate('/dateAndTime/' + event.id)
        } else {
          errorMessage = 'Internal server error'
          return errorMessage
        }
      }
    } catch (error: any) {
      errorMessage = 'Internal server error'
      return errorMessage
    }
    return errorMessage
  }

  return (
    <Box width={'100%'} sx={{ my: '20px' }}>
      <Accordion>
        <AccordionSummary
          expandIcon={
            <Box component='img' src={ExpandMoreIcon} alt='ExpandMoreIcon' sx={{width: '17px'}} />
          }
          aria-controls='panel1a-content'
          id='panel1a-header'
          sx={{
            '.MuiAccordionSummary-expandIconWrapper.Mui-expanded ': {
              transform: 'rotate(-90deg)'
            }
          }}
        >
          <Typography sx={{ fontSize: '24px', fontWeight: 500 }}>
            Speakers & Support Staff
            <Box sx={{ color: 'error.main', display: 'inline' }}>{' '} *</Box>
          </Typography>
          <Typography variant='body2' style={{ flex: 1, textAlign: 'right' }}>
            If TBD is selected, the default from the series template will be used. Add people to override.
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box
            sx={{
              bgcolor: 'white',
              borderRadius: '4px',
              marginTop: '1rem'
            }}
            key='Moderators'
          >
            <Approver
              setTbdPresenters={setTbdPresenters}
              setTbdModerators={setTbdModerators}
              setTbdSupportstaff={setTbdSupportstaff}
              eventData={event}
              isRequired
              title='Moderators'
              staff_type={StaffType.MODERATORS}
              staff={staff}
              onStaffChange={staff =>
                handleStaffChange(staff, StaffType.MODERATORS)
              }
              staffErrors={moderatorErrors}
            />
          </Box>
          <Box
            sx={{
              bgcolor: 'white',
              borderRadius: '4px',
              marginTop: '1rem'
            }}
          >
            <Approver
              setTbdPresenters={setTbdPresenters}
              setTbdModerators={setTbdModerators}
              setTbdSupportstaff={setTbdSupportstaff}
              eventData={event}
              isRequired
              title='Presenters'
              staff_type={StaffType.PRESENTERS}
              staff={staff}
              onStaffChange={staff =>
                handleStaffChange(staff, StaffType.PRESENTERS)
              }
              staffErrors={presenterErrors}
            />
          </Box>
          <Box
            sx={{
              bgcolor: 'white',
              borderRadius: '4px',
              marginTop: '1rem'
            }}
            key='Support Staff'
          >
            <Approver
              setTbdPresenters={setTbdPresenters}
              setTbdModerators={setTbdModerators}
              setTbdSupportstaff={setTbdSupportstaff}
              eventData={event}
              title='Support Staff'
              staff_type={StaffType.SUPPORT_STAFF}
              staff={staff}
              onStaffChange={staff =>
                handleStaffChange(staff, StaffType.SUPPORT_STAFF)
              }
            />
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  )
})
export default SpeakerAndStaffSupport
